import { render, staticRenderFns } from "./AddPlace.vue?vue&type=template&id=0b9aa58e&scoped=true&"
import script from "./AddPlace.vue?vue&type=script&lang=js&"
export * from "./AddPlace.vue?vue&type=script&lang=js&"
import style0 from "./AddPlace.vue?vue&type=style&index=0&lang=less&"
import style1 from "./AddPlace.vue?vue&type=style&index=1&id=0b9aa58e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9aa58e",
  null
  
)

export default component.exports